import { motion } from "framer-motion";

const Intro = () => {
  return (
    <motion.section
      className="min-h-screen bg-gradient-to-b from-blue-900 to-gray-900 flex flex-col justify-center items-center text-white  px-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Animated Heading */}
      <motion.div
        className="text-center relative"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="absolute top-0 left-1/2 transform -translate-x-1/2 h-20 w-20 bg-teal-400 opacity-20 blur-3xl rounded-full"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.2, delay: 0.2 }}
        ></motion.div>
      </motion.div>

      {/* Animated Paragraph */}
      <motion.div
        className="mt-8 max-w-3xl  bg-opacity-10 p-8 rounded-xl shadow-xl"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <p className="text-lg md:text-xl leading-relaxed text-gray-300">
          Hi! I'm a{" "}
          <span className="text-teal-400 font-semibold">React enthusiast</span>{" "}
          and an aspiring web developer who enjoys bringing ideas to life
          through code. My journey into programming started with curiosity and
          turned into a passion for building dynamic and user-friendly
          interfaces.
          <br />
          <br />I love working with React's modular components, and I'm
          constantly exploring ways to make the digital world more exciting.
          Collaboration and learning are my driving forces—let's create
          something amazing together!
        </p>
      </motion.div>

      {/* Call to Action */}
      <motion.div
        className="mt-10"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.8 }}
      >
        <a
          href="https://www.linkedin.com/in/susan-khatri-3a1869260/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-6 py-3 bg-teal-400 text-gray-900 font-semibold rounded-lg shadow-lg hover:bg-teal-500 hover:scale-105 transition-all duration-300"
        >
          Connect with Me 🚀
        </a>
      </motion.div>
    </motion.section>
  );
};

export default Intro;
